import React, { useEffect, useRef } from 'react';
import * as Scrivito from 'scrivito';
import { ReactComponent as IconSearch } from '../../../../../assets/icons/icon-search.svg';
import { ReactComponent as IconSearchDot } from '../../../../../assets/icons/icon-search-dot.svg';
import { ReactComponent as IconClose } from '../../../../../assets/icons/icon-close.svg';
import styles from './navigation-drawer-header.module.scss';
import { SearchAttributes } from '../../../../../pages/home-page/home-page-search';
import { useTranslation } from 'react-i18next';
import { LinkComponent } from '../../../link/link';

interface NavigationDrawerHeaderProps {
  title?: string;
  onClick: () => void;
  onButtonClose: () => void;
}

export const NavigationDrawerHeader: React.FC<NavigationDrawerHeaderProps> = Scrivito.connect((props) => {
  const root = Scrivito.Obj.root();
  const { t } = useTranslation();
  const searchPageLink = root?.get(SearchAttributes.SEARCH_PAGE);
  const backButtonAriaLabel = t('component.navigation.backButtonAriaLabel');
  const closeButtonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    closeButtonRef?.current?.focus();
  }, []);

  return (
    <div className={styles.NavigationDrawerHeader}>
      <div className={styles.TitleAndBackButtonArea}>
        {props.title && (
          <button aria-label={`${backButtonAriaLabel}`} className={styles.BackButton} onClick={props.onClick}>
            <span />
          </button>
        )}
        <div className={styles.Title}>
          <span>{props.title ?? ''}</span>
        </div>
      </div>

      <div className={styles.IconsArea}>
        <LinkComponent
          to={searchPageLink as Scrivito.Link}
          className={styles.Red}
          accessibilityText={t('component.navigation.searchButtonTitle')}
          onClick={props.onButtonClose}
        >
          <IconSearch className={styles.NotHover} />
          <IconSearchDot className={styles.HoverOnly} />
        </LinkComponent>
        <button
          id="mobileMenuCloseButton"
          onClick={props.onButtonClose}
          ref={closeButtonRef}
          aria-label={t('component.navigation.closeMenuButtonTitle')}
        >
          <IconClose />
        </button>
      </div>
    </div>
  );
});
// focus navigation header buttons background color fixed
// navigation header back is now a real "button"
// navigation header back button has now correct aria label
// fixed that pressing on search does not close the navigation
